import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import "../styles/View.css";

function View() {
  const [reviews, setReviews] = useState([]);
  const [users, setUsers] = useState([]); // ✅ add state for users
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);


  useEffect(() => {
    async function fetchReviews() {
      const reviewsQuery = query(
        collection(db, "reviews"),
        orderBy("createdAt", "desc"),
      );
      const querySnapshot = await getDocs(reviewsQuery);
      const reviewList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setReviews(reviewList);
    }

    async function fetchUsers() {
      const usersSnapshot = await getDocs(collection(db, "users"));
      const userList = usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(userList); // ✅ store users
    }

    fetchReviews();
    fetchUsers(); // ✅ also fetch users
  }, []);


    const groupedData = reviews.reduce((acc, review) => {
      const hotel = review.hotelName || "Unknown Hotel";
      const email = review.userEmail || "Unknown Email";

      if (!acc[hotel]) acc[hotel] = {};
      if (!acc[hotel][email]) acc[hotel][email] = [];

      acc[hotel][email].push(review);
      return acc;
    }, {});

    // Sort & limit to 30 reviews per email
    Object.keys(groupedData).forEach((hotel) => {
      Object.keys(groupedData[hotel]).forEach((email) => {
        groupedData[hotel][email] = groupedData[hotel][email]
          .sort((a, b) => b.createdAt?.toMillis?.() - a.createdAt?.toMillis?.()) // newest first
          .slice(0, 45); // limit 30 per email
      });
    });

    // ✅ Top 10 recent records
   const recent10 = [...reviews]
      .sort((a, b) => b.createdAt?.toMillis?.() - a.createdAt?.toMillis?.())
      .filter((review) => {
        const user = users.find((u) => u.email === review.userEmail);
        return user?.role?.toLowerCase() !== "security"; // ❌ exclude security users 
      })
      .slice(0, 10);


  return (
    <div className="admin-container">
      <h2 style={{color:"black"}}>Super Admin Panel - Latest Reviews</h2>

      {/* Button to go to History page */}
      <button
        onClick={() => navigate("/viewsp")}
        className="history-btn"
      >
        Security Points Reviews 
      </button>
      

       {/* ✅ Show top 10 recent records */}
      <div className="recent-section">
        <h3>Recently Submitted (Last 10)</h3>
        <div className="table1">
          <table className="review-table">
            <thead>
              <tr>
                <th>Date</th>
                {/* <th>NO</th> */}                
                <th>QR Data</th>
                <th>User</th>
                <th>Rating</th>
                <th>Hotel Issues</th>
                <th>Maintenance Issues</th>
                <th>Image</th>
                {/* <th>User IP</th> */}
                <th>Location</th> 
                
              </tr>
            </thead>
            <tbody>
              {recent10.map((review, index) => {
                const reviewDate = review.createdAt?.toDate ? review.createdAt.toDate() : null;

                  // Check if the review was submitted today
                  const isToday =
                    reviewDate &&
                    reviewDate.toDateString() === new Date().toDateString();

                  // ✅ Format date as DD/MM/YYYY and time as HH:mm:ss (24h)
                  const formattedDateTime = reviewDate
                  ? `${reviewDate.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" })} ${reviewDate.toLocaleTimeString("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}`
                  : "";

                  return (
                    <tr
                      key={review.id}
                      className={`
                        ${review.rating <= 3 ? "low-rating" : ""}
                        ${isToday ? "today-review" : "older-review"}
                      `}
                      >
                    {/* <td>{index + 1}</td> */}
                     <td>{formattedDateTime}</td>
                    <td>{review.qrData || "N/A"}</td>
                    <td>{review.userEmail ? review.userEmail.split('@')[0] : "Unknown"}</td>                    
                    <td>{review.rating}/5</td>
                    <td>{review.issueHotel}</td>
                    <td>{review.issueMaintenance}</td>
                   <td>
                       {review.imageUrls && review.imageUrls.length > 0 ? (
                        <div className="thumbnail-row">
                          {review.imageUrls.map((url, idx) => (
                            <img
                              key={idx}
                              src={url}
                              alt={`Uploaded ${idx + 1}`}
                              className="review-thumbnail"
                              onClick={() => setSelectedImage(url)} // open popup
                            />
                          ))}
                        </div>
                      ) : (
                        "No image"
                      )}
                      </td>
                    {/* <td>{review.userIp || "Unknown"}</td> */}
                    <td>
                      {review.location?.lat && review.location?.lng ? (
                        <a
                          href={`https://www.google.com/maps?q=${review.location.lat},${review.location.lng}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Location
                        </a>
                      ) : (
                        "No Location"
                      )}
                    </td>
                   
                  </tr>
                );
              })}
            </tbody>
          </table>
          
          {selectedImage && (
            <div className="image-modal" onClick={() => setSelectedImage(null)}>
              <span className="close-btn">&times;</span>
              <img src={selectedImage} alt="Full view" className="modal-content" />
            </div>
          )}
        </div>
      </div><br></br>

      {Object.keys(groupedData).map((hotel) => (
        <div key={hotel} className="hotel-section">
          <h3>{hotel}</h3>

          {/* User Tabs */}
          <div className="table1">
          <div className="tab-container">
            {Object.keys(groupedData[hotel]).map((email) => {
              const user = users.find((u) => u.email === email);
              const role = user?.role || "guest"; 

              if (role === "security") return null;

              return (
                <button
                  key={email}
                  className={`tab-btn ${selectedUser === email ? "active selected-email" : ""}`}
                  onClick={() => setSelectedUser(email)}
                >
                  {email} {role === "security" && "(Security)"}
                </button>
              );
            })}
          </div>

        {/* Show table only if role is security */}
          {selectedUser && groupedData[hotel][selectedUser] && (() => {
            const user = users.find((u) => u.email === selectedUser);
            const role = user?.role || "guest";

            return role !== "security" ? ( 
            <table className="review-table">
              <thead>
                <tr>
                  {/* <th>NO</th> */}
                  <th>Date</th>
                  <th>QR Data</th>
                  <th>Rating</th>
                  <th>Hotel Issues</th>
                  <th>Maintenance Issues</th>
                  <th>Image</th>
                  {/* <th>User IP</th> */}
                  <th>Location</th>
                  
                </tr>
              </thead>
              <tbody>
                {groupedData[hotel][selectedUser].map((review, index) => {
              // Convert Firestore timestamp to JS Date
              const reviewDate = review.createdAt?.toDate ? review.createdAt.toDate() : null;

                  // Check if the review was submitted today
                  const isToday =
                    reviewDate &&
                    reviewDate.toDateString() === new Date().toDateString();

                  // ✅ Format date as DD/MM/YYYY and time as HH:mm:ss (24h)
                  const formattedDateTime = reviewDate
                    ? `${reviewDate.toLocaleDateString("en-GB")} ${reviewDate.toLocaleTimeString("en-GB", {
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      })}`
                    : "";

                  return (
                    <tr
                      key={review.id}
                      className={`
                        ${review.rating <= 3 ? "low-rating" : ""}
                        ${isToday ? "today-review" : "older-review"}
                      `}
                      >
                      {/* New Number Column */}
                      {/* <td>{index + 1}</td> */}
                      <td>{formattedDateTime}</td>
                      <td>{review.qrData || "N/A"}</td>
                      <td>{review.rating}/5</td>
                      <td>{review.issueHotel}</td>
                      <td>{review.issueMaintenance}</td>
                       <td>
                       {review.imageUrls && review.imageUrls.length > 0 ? (
                        <div className="thumbnail-row">
                          {review.imageUrls.map((url, idx) => (
                            <img
                              key={idx}
                              src={url}
                              alt={`Uploaded ${idx + 1}`}
                              className="review-thumbnail"
                              onClick={() => setSelectedImage(url)} // open popup
                            />
                          ))}
                        </div>
                      ) : (
                        "No image"
                      )}
                      </td>
                      {/* <td>{review.userIp || "Unknown"}</td> */}
                      <td>
                        {review.location && review.location.lat && review.location.lng ? (
                          <a
                            href={`https://www.google.com/maps?q=${review.location.lat},${review.location.lng}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Location
                          </a>
                        ) : (
                          "No Location"
                        )}
                      </td>
                     
                    </tr>
                  );
                })}
              </tbody>

            </table>
             ) : null
            
          })()}
        </div>
      </div>
      ))}
    </div>
  );
}

export default View;  